import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import DashTransConfirm from "./DashTransConfirm";
import { BsArrowLeft } from "react-icons/bs";

const TransPop1 = () => {
  const [pop, setPop] = useState(false);

  const popOut = () => {
    setPop(!pop);
  };

  return (
    <div>
      <Contain>
        <Pop>
          <Tap>
            <Label>Enter Amount To Withdraw</Label>

            <Here type="" placeholder="Tap here and enter .. (e.g 5000)" />
          </Tap>

          <Select1>
            <Label>Select Bank</Label>
            <Select>
              <option value="">--Select--</option>
            </Select>
          </Select1>

          <Tap>
            <Label>Account Number</Label>

            <Here type="number" placeholder="0123456789" />
          </Tap>

          <Tap>
            <Label>Account Name</Label>

            <Here type="text" placeholder="Ade Obi Musa" />
          </Tap>

          <Start onClick={popOut}>Continue</Start>

          <NavLink
            to="/transactions"
            style={{ textDecoration: "none", marginTop: "7px" }}
          >
            <p style={{ fontSize: "11px", cursor: "pointer" }}>
              Back to Transactions
            </p>
          </NavLink>
        </Pop>

        {pop ? (
          <div
            style={{
              width: "100%",
              height: "100vh",
              backgroundColor: "#ffffff7b",
              position: "absolute",
              top: "0",
              left: "0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backdropFilter: "blur(7px)",
              transitionTimingFunction: "ease-in-out",
              transition: "0.25s",
            }}
          >
            <Pop2>
              <Icon onClick={popOut}>
                <BsArrowLeft />
              </Icon>

              <DashTransConfirm />
            </Pop2>
          </div>
        ) : null}
      </Contain>
    </div>
  );
};

export default TransPop1;

const Icon = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 17px;
  /* z-index: 10; */
  color: #8a2be2;
`;

const Select = styled.select`
  width: 100%;
  height: 34px;
  border-radius: 7px 7px 7px 0;
  border: none;
  border-bottom: 1px solid #8a2be2;
  border-right: 1px solid #8a2be2;
  outline: none;
`;

const Select1 = styled.div`
  width: 84%;
`;

const Pop2 = styled.div`
  width: 280px;
  height: 350px;
  background-color: white;
  box-shadow: 0 0 2px gray;
  color: #ffffff7b;
  position: relative;
  border-radius: 7px 7px 7px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Start = styled.button`
  width: 85%;
  height: 35px;
  border-radius: 7px 7px 7px 0;
  margin-top: 25px;
  border: none;
  background-color: #8a2be2;
  color: white;
  font-weight: 700;
  cursor: pointer;
`;

const Here = styled.input`
  width: 100%;
  height: 30px;
  border-radius: 7px 7px 7px 0;
  border: none;
  border-bottom: 1px solid #8a2be2;
  border-right: 1px solid #8a2be2;
  outline: none;
  // padding-left: 5px;
`;

const Label = styled.div`
  margin-top: 30px;
  margin-bottom: 7px;
  font-size: 12px;
  font-weight: 700;
  color: #8a2be2;
  // color: gray;
`;

const Tap = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
`;

const Contain = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  margin-top: -30px;
  justify-content: center;
  align-items: center;
  position: relative;

  @media screen and (max-width: 820px) {
    margin-top: 0;
  }
`;

const Pop = styled.div`
  width: 270px;
  height: 490px;
  box-shadow: 0px 0px 2px gray;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 7px 7px 7px 0;
`;
